module.exports = __webpack_public_path__ + "img/chevron-down.b9b49e994d33b1d79017f84d74b70342.svg";